"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var Sync_1 = require("@twii/core/lib/model/Sync");
var ListingReviewModel = /** @class */ (function () {
    function ListingReviewModel(listingRef) {
        var _this = this;
        this.sync = new Sync_1.Sync();
        this.rate = null;
        this._onSaveDone = function (data) {
            _this.setData(data);
            _this.sync.syncEnd();
        };
        this._onSaveError = function (error) {
            _this.sync.syncError(error);
        };
        this.setListingRef(listingRef);
    }
    ListingReviewModel.prototype.setListingRef = function (listingRef) {
        this.listingRef = listingRef;
    };
    ListingReviewModel.prototype.setRate = function (rate) {
        this.rate = rate;
    };
    ListingReviewModel.prototype.setText = function (text) {
        this.text = text;
    };
    Object.defineProperty(ListingReviewModel.prototype, "data", {
        get: function () {
            return {
                id: this.id,
                rate: this.rate,
                text: this.text,
                listing: this.listingRef ? this.listingRef.id : undefined
            };
        },
        set: function (value) {
            this.setData(value);
        },
        enumerable: true,
        configurable: true
    });
    ListingReviewModel.prototype.setData = function (data) {
        this.id = data ? data.id : undefined;
        this.author = data ? data.author : undefined;
        this.rate = data ? data.rate : undefined;
        this.text = data ? data.text : undefined;
        this.edited_date = data ? data.edited_date : undefined;
        this.created_date = data ? data.created_date : undefined;
    };
    ListingReviewModel.prototype.save = function () {
        // TODO: validate
        this.sync.syncStart();
        return ListingServiceContext_1.ListingServiceContext.value.saveListingReview(this.data).then(this._onSaveDone).catch(this._onSaveError);
    };
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "sync", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "listingRef", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "author", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "rate", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "text", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "edited_date", void 0);
    __decorate([
        mobx_1.observable
    ], ListingReviewModel.prototype, "created_date", void 0);
    __decorate([
        mobx_1.action
    ], ListingReviewModel.prototype, "setListingRef", null);
    __decorate([
        mobx_1.action
    ], ListingReviewModel.prototype, "setRate", null);
    __decorate([
        mobx_1.action
    ], ListingReviewModel.prototype, "setText", null);
    __decorate([
        mobx_1.computed
    ], ListingReviewModel.prototype, "data", null);
    __decorate([
        mobx_1.action
    ], ListingReviewModel.prototype, "setData", null);
    __decorate([
        mobx_1.action
    ], ListingReviewModel.prototype, "save", null);
    return ListingReviewModel;
}());
exports.default = ListingReviewModel;
exports.ListingReviewModel = ListingReviewModel;
